import { default as OriginalMenu } from "./Menu";
import MenuButton from "./MenuButton";
import MenuList from "./MenuList";
import MenuHeader from "./MenuHeader";
import MenuDivider from "./MenuDivider";
import MenuLink from "./MenuLink";
import MenuLinkExternal from "./MenuLinkExternal";
import MenuItem from "./MenuItem";
var Menu = OriginalMenu;
Menu.Button = MenuButton;
Menu.List = MenuList;
Menu.Header = MenuHeader;
Menu.Divider = MenuDivider;
Menu.Link = MenuLink;
Menu.LinkExternal = MenuLinkExternal;
Menu.Item = MenuItem;
export default Menu;
